import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** *********************  START ADD PRODUCT DETAILS ******************** */
export const addProductLoanProposal = (listData: any) => {
	const data = {
		AddProductLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}addProductLoanIndex`;
	return makeApiCall(url, data);
};
/** *********************  END ADD PRODUCT DETAILS ******************** */

/** *********************  START UPDATE PRODUCT DETAILS ******************** */
export const updateProductLoanProposal = (listData: any) => {
	const data = {
		UpdateProductLoanIndexDetailsToken: listData,
	};
	const url = `${API_URL}updateProductLoanIndex`;
	return makeApiCall(url, data);
};
/** *********************  END UPDATE PRODUCT DETAILS ******************** */
